import { socialLinks } from '../constants/socialLinks';

export const agileProductBuilders = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Boldare Agile Product Builders Community',
  url: 'https://www.boldare.com/agile-product-builders/',
  description:
    'A community space where people from both sides of the product-building spectrum can freely interact. Membership includes a community monthly newsletter with an option to unsubscribe anytime.',
  memberOf: {
    '@type': 'Organization',
    name: 'Boldare',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Community Membership',
    itemListElement: {
      '@type': 'Offer',
      name: 'Monthly Newsletter Subscription',
      description: 'Community monthly newsletter with unsubscribe option.',
    },
  },
  sameAs: Object.values(socialLinks),
};
